<h1 class="pageHeading">Calendars</h1>

<form [formGroup]="form">
    
</form>

<table class="table table-bordered mt-4" *ngIf="calendars && calendars.length">
  <thead>
    <tr>
      <th>Calendar Name</th>
      <th>Start Date</th>
      <th>End Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let calendar of calendars">
      <td>{{ calendar.name }}</td>
      <td>{{ calendar.startDate | date:'MMMM d' }}</td>
      <td>{{ calendar.endDate | date:'MMMM d' }}</td>
    </tr>
  </tbody>
</table>

<h1 class="pageHeading">Add New Calendar</h1>
<br />
<table class="table">
  <tr>
    <th>Calendar Name</th>
    <th>Start Date</th>
  </tr>
  <tr>
    <td><input type="text" placeholder="Calendar Name" [(ngModel)]="selectedCalendarId" /></td>
    <td>
      <select class="form-control" name="month" [(ngModel)]="selectedMonth"
              (change)="onMonthChange($event.target.value)">
        <option *ngFor="let month of ['Month', 1,2,3,4,5,6,7,8,9,10,11,12]" [value]="month">{{ month }}</option>
      </select>
    </td>
    <td>
      <select class="form-control" name="day" [(ngModel)]="selectedDay">
        <option *ngFor="let day of getDays()" [value]="day">{{ day }}</option>
      </select>
    </td>
    <td><button class="btn btn-primary" (click)="save()">Add Calendar</button></td>
  </tr>
</table>